import React from 'react';
import {Card} from '../../../../_metronic/_partials/controls';
import {PartnersFilter} from '../components/partners-filter/PartnersFilter';
import {PartnersTable} from '../components/partners-table/PartnersTable';
import {PartnersFooter} from '../components/partners-footer/PartnersFooter';
import FooterBar from '../../_common/components/FooterBar';

export function PartnersCard() {

  return (
    <Card className={'flex-fill bg-transparent shadow-none'} id={'partners-list-card'}>
        <PartnersFilter/>
      <PartnersTable/>
      <FooterBar>
        <PartnersFooter/>
      </FooterBar>
    </Card>
  );
}
